import { DirectUpload } from "activestorage";
import { apiClient } from "./lib/apiClient";
import { V1FileData } from "./lib/datasetVersions/v1";
import { V2FileData } from "./lib/datasetVersions/v2";
import RegressionModel from "./types/RegressionModel";

// Dataset Management
export async function persistDataset(
  adjustmentId: string,
  signedId: string,
  datasetSchemaVersion: string,
) {
  return apiClient.postData(`/adjustments/${adjustmentId}/data`, {
    signed_id: signedId,
    schema_version: datasetSchemaVersion,
  });
}

export async function clearDataset(adjustmentId: string) {
  return apiClient.postData(`/adjustments/${adjustmentId}/data/clear`);
}

// Outlier Management
export async function addOutliers(adjustmentId: string, ids: string[]) {
  return apiClient.postData(`/adjustments/${adjustmentId}/trend/add_outliers`, {
    ids,
  });
}

export async function removeOutlier(adjustmentId: string, id: string) {
  return apiClient.postData(`/adjustments/${adjustmentId}/trend/remove_outlier`, {
    id,
  });
}

// Regression Model Management
export async function setRegressionModel(adjustmentId: string, model: RegressionModel) {
  return apiClient.postData(`/adjustments/${adjustmentId}/trend/set_regression_model`, {
    model,
  });
}

// Comparable Property Management
export async function addComp(adjustmentId: string, compId: string) {
  return apiClient.postData(`/adjustments/${adjustmentId}/comps/add_comp`, {
    id: compId,
  });
}

export async function removeComp(adjustmentId: string, compId: string) {
  return apiClient.postData(`/adjustments/${adjustmentId}/comps/remove_comp`, {
    id: compId,
  });
}

// Dataset Upload and Persistence
export async function saveDataset(
  adjustmentId: string,
  sheet: V2FileData | V1FileData,
  directUploadUrl: string,
  datasetSchemaVersion: string,
) {
  const blob = new Blob([JSON.stringify(sheet)]);
  const file = new File([blob], `${adjustmentId}.dataset.json`, {
    type: "application/json",
  });

  const upload = new DirectUpload(file, directUploadUrl);
  const result: any = await createActiveStorageUpload(upload);
  const signedId = result.signed_id as string;

  return persistDataset(adjustmentId, signedId, datasetSchemaVersion);
}

// Active Storage Upload Helper
async function createActiveStorageUpload(upload: DirectUpload) {
  return new Promise((resolve, reject) => {
    upload.create((error: any, blob: any) => {
      if (error) {
        reject(error);
      } else {
        resolve(blob);
      }
    });
  });
}

// Admin API Functions
export async function fetchUsers() {
  return apiClient.getData<Array<{ email: string }>>("/admin/api/users");
}

// PDF Generation
export async function generatePdf(adjustmentId: string) {
  return apiClient.postData(`/adjustments/${adjustmentId}/summary/generate_pdf`);
}
